import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export function initSimilarProjectSlider() {
    const projectRelatedSlider = new Swiper(".project-related-slider", {
        slidesPerView: 1,
        spaceBetween: 16,
        pagination: {
            el: ".project-related-slider-pagination",
            type: "progressbar",
        },
        navigation: {
            nextEl: ".project-related-slider-next",
            prevEl: ".project-related-slider-prev",
        },
        breakpoints: {
            380: {
                slidesPerView: 2,
                spaceBetween: 16,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 18,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
        },
    });
    window.addEventListener('resize', checkSimilarProjectNavigationWrapperStatus);
    // Call the function initially
    checkSimilarProjectNavigationWrapperStatus();
    return projectRelatedSlider
}

function checkSimilarProjectNavigationWrapperStatus(){
    const otherNewsNavigationWrapper = document.querySelector(".project-related__slider-action");
    const otherNewsSliderNext = document.querySelector(".project-related-slider-next");
    // Check if the element has the class "swiper-button-lock"
    if (otherNewsSliderNext.classList.contains("swiper-button-lock")) {
        otherNewsNavigationWrapper.classList.add('d-none');
    } else {
        otherNewsNavigationWrapper.classList.remove('d-none');
    }
}

